import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    }
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Page Not Found (404) | Smile Care Dental</title>
        <meta
          name="description"
          content="The page you're looking for doesn't exist. Return to Smile Care Dental's homepage to book a dental appointment in Gandhinagar."
        />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Page Not Found (404) | Smile Care Dental" />
        <meta
          property="og:description"
          content="The page you're looking for doesn't exist. Return to Smile Care Dental's homepage."
        />
        <meta property="og:url" content="https://smilecaredentalgandhinagar.lovable.app/404" />
        <link rel="canonical" href="https://smilecaredentalgandhinagar.lovable.app/404" />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            Return to Home
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
